import { render, staticRenderFns } from "./FavoritesListComponent.vue?vue&type=template&id=5300099e"
import script from "./FavoritesListComponent.vue?vue&type=script&lang=js"
export * from "./FavoritesListComponent.vue?vue&type=script&lang=js"
import style0 from "./FavoritesListComponent.vue?vue&type=style&index=0&id=5300099e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports